import { Box } from "@material-ui/core";
import React from "react";
import ErrorSection from "../ErrorSection/ErrorSection";
import Form from "../Form/Form";
import Main from "../Main/Main";
import Steps from "../Steps/Steps";

export default function Content({
  data,
  tracking_number,
  postal_code,
  error,
  dataLoaded,
  postalCode,
  postalAvailable,
  setInputValues,
  tooltipOpen,
  setTooltipOpen
}: {
  data: any;
  tracking_number: string | undefined;
  postal_code: string | undefined;
  error: string | undefined;
  dataLoaded: boolean;
  tooltipOpen: boolean;
  postalAvailable: boolean | undefined;
  postalCode: string | undefined;
  setTooltipOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setInputValues: React.Dispatch<React.SetStateAction<any>>;
}) {
  return (
    <Box>
      <Form
        tracking_number={tracking_number}
        postal_code={postal_code}
        setInputValuesGlobal={setInputValues}
        postalAvailable={postalAvailable}
        tooltipOpen={tooltipOpen}
        setTooltipOpen={setTooltipOpen}
      />
      {error ? (
        <ErrorSection />
      ) : (
        <>
          <Steps data={data} />
          <Main
            data={data}
            setTooltipOpen={setTooltipOpen}
            dataLoaded={dataLoaded}
            postalCode={postalCode}
            postalAvailable={postalAvailable}
          />
        </>
      )}
    </Box>
  );
}
